import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectYear } from '../redux/carDuck';
import { fetchYears } from '../redux/apiDuck';
import { useHistory } from 'react-router-dom';
import ListItem from '../components/ListItem';
import List from '../components/List';
import Card from '../components/Card';
import Typography from '../components/Typography';
import Loader from '../components/Loader';

export const ThirdStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { years, fetching } = useSelector((state) => state.api);
  const { brandID, model } = useSelector((state) => state.car);

  useEffect(() => {
    dispatch(fetchYears(brandID, model));
  }, [dispatch, brandID, model]);

  const addOkmToYears = (years) => {
    const now = new Date();
    const currentYear = now.getFullYear().toString();

    const yearFound = years.find((year) => year.codigo === currentYear);
    if (!yearFound) return years;

    const newYear = { codigo: `${currentYear} 0KM`, descripcion: currentYear };
    return [newYear, ...years];
  };

  const handleSelectYear = ({ codigo, descripcion }) => {
    if (codigo.includes('0KM')) {
      dispatch(selectYear(descripcion, '1'));
    } else {
      dispatch(selectYear(descripcion, '0'));
    }

    history.push('/versiones');
  };

  if (fetching) return <Loader />;

  return (
    <>
      <Typography text='¿Cúal es el año de tu auto?' />
      <Card>
        <List>
          {addOkmToYears(years).map((year) => (
            <ListItem key={year.codigo} text={year.codigo} handleClick={() => handleSelectYear(year)} />
          ))}
        </List>
      </Card>
    </>
  );
};
